export const LEGAL_NOTICE_LOADING = 'LEGAL_NOTICE_LOADING';
export const LEGAL_NOTICE_SUCCESS = 'LEGAL_NOTICE_SUCCESS';
export const LEGAL_NOTICE_ERROR = 'LEGAL_NOTICE_ERROR';
export const LEGAL_NOTICE_CLEAR_ERROR = 'LEGAL_NOTICE_CLEAR_ERROR';
export const LEGAL_NOTICE_CLEAR_APPLICATION = 'LEGAL_NOTICE_CLEAR_APPLICATION';

export const LEGAL_NOTICE_FETCH_PROPERTY_DETAILS_SUCCESS = 'LEGAL_NOTICE_FETCH_PROPERTY_DETAILS_SUCCESS';

export const LEGAL_NOTICE_FETCH_APPLICATION_DETAILS_SUCCESS = 'LEGAL_NOTICE_FETCH_APPLICATION_DETAILS_SUCCESS';
export const LEGAL_NOTICE_FETCH_CONTRACT_DETAILS_SUCCESS = 'LEGAL_NOTICE_FETCH_CONTRACT_DETAILS_SUCCESS';

export const LEGAL_NOTICE_CHANGE_WORKFLOW_STEP = 'LEGAL_NOTICE_CHANGE_WORKFLOW_STEP';

export const LEGAL_NOTICE_SAVE_APPLICATION_SUCCESS = 'LEGAL_NOTICE_SAVE_APPLICATION_SUCCESS';

export const LEGAL_NOTICE_FETCH_DOCUMENTS_SUCCESS = 'LEGAL_NOTICE_FETCH_DOCUMENTS_SUCCESS';

export const LEGAL_NOTICE_FIELD_CHANGE = 'LEGAL_NOTICE_FIELD_CHANGE';
export const LEGAL_NOTICE_FORM_ERROR = 'LEGAL_NOTICE_FORM_ERROR';

export const LEGAL_NOTICE_FETCH_NON_UAE_USERS = 'LEGAL_NOTICE_FETCH_NON_UAE_USERS';
export const LEGAL_NOTICE_FETCH_NON_UAE_USERS_SUCCESS = 'LEGAL_NOTICE_FETCH_NON_UAE_USERS_SUCCESS';
